import React from 'react'
import { AiFeaturePreset } from '../../../../../models/AiFeaturePreset'
import { CurrentUserPresetTemplateConfigForm } from './Hierarchy/CurrentUserPresetTemplateConfigForm'
import { TeamMemberPresetTemplateConfigForm } from './Hierarchy/TeamMemberPresetTemplateConfigForm'
import { MeetingTemplateInputParametersHierarchyConfigModal } from '../../../../../components/InputParameterHierarchy/MeetingTemplateInputParametersHierarchyConfigModal'
import { MeetingTemplateGlobalPresetTemplateConfigForm } from './Hierarchy/MeetingTemplateGlobalPresetTemplateConfigForm'
import { InputParameterHierarchyType } from '../../../../../components/InputParameterHierarchy/model'
import { useGlobalFormPresetInputParameters } from '../hooks'

export interface MeetingTemplatePresetTemplateConfigModalProps {
  show: boolean
  onHide: () => void
  preset: AiFeaturePreset
  meetingTemplateId: string
}

export const MeetingTemplatePresetTemplateConfigModal: React.FC<MeetingTemplatePresetTemplateConfigModalProps> = ({
  show,
  onHide,
  preset,
  meetingTemplateId,
}) => {
  const { presetInputParameters } = useGlobalFormPresetInputParameters(preset)

  return (
    <MeetingTemplateInputParametersHierarchyConfigModal
      show={show}
      onHide={onHide}
      type={InputParameterHierarchyType.AI_FEATURE_PRESET}
      typeId={preset.id}
      name={preset.name}
      defaultInputParameters={presetInputParameters}
      inputParametersSchema={preset.inputParametersSchema}
      meetingTemplateId={meetingTemplateId}
      MeetingTemplateConfig={MeetingTemplateGlobalPresetTemplateConfigForm}
      CurrentUserConfig={CurrentUserPresetTemplateConfigForm}
      TeamMembersConfig={TeamMemberPresetTemplateConfigForm}
    />
  )
}
